import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      meta: { main_page: true },
      component: () => import("@/core/plugins/TitleRibbon/index"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          meta: { main_page: true },
          component: () => import("@/core/plugins/TitleRibbon/Dashboard"),
        },
        {
          path: "/chat",
          name: "open-router-chat",
          component: () => import("./view/pages/newChat/chatBot.vue"),
          meta: { title: "چت بات", has_ribbon: true },
        },

        {
          path: "/image",
          name: "picSelector",
          component: () => import("./view/pages/image/picSelector.vue"),
          meta: { title: "خلق تصویر", has_ribbon: true },
        },
         {
          path: "/token",
          name: "token",
          component: () => import("./view/pages/token/listToken.vue"),
          meta: { title: "مدیریت توکن", has_ribbon: true , Permissions:'managment_token'},
        },
        {
          path: "/design",
          name: "design.image",
          component: () => import("./view/pages/design/designImage.vue"),
          meta: { title: "طراحی عکس محصول", has_ribbon: true },
        },
        {
          path: "/uploader",
          name: "uploadCenter",
          component: () => import("./components/UploadCenter/Uploader.vue"),
          meta: { title: "آپلود سنتر", has_ribbon: true },
        },
        {
          path: "/designQr",
          name: "qrDesign",
          component: () => import("./view/pages/aiDesign/aiDesign.vue"),
          meta: { title: "دیزاین هوشمند", has_ribbon: true },
        },
        {
          path: "/AssistantAi",
          name: "assistantAi",
          component: () => import("./view/pages/aiAssistant/AssistantAi.vue"),
          meta: { title: "دستیار هوشمند", has_ribbon: true },
        },
        {
          path: "/AssistantAi/Monitoring",
          name: "AssistantAi.Monitoring",
          component: () =>
            import("./view/pages/aiAssistant/AssistantAiMonitoring.vue"),
          meta: { title: "مونیتورینگ دستیار هوشمند", has_ribbon: true },
        },
        {
          path: "/assistant/design/:id",
          name: "DesignAssistant",
          component: () => import("./view/pages/aiAssistant/settingLayout.vue"),
          props: true,
          meta: { title: "ویرایش دیزاین دستیار", has_ribbon: true },
        },
      ],
    },
    {
      path: "/assistantchat/:key",
      name: "assistant-chat",
      component: () => import("./view/pages/aiAssistant/assistantChatView.vue"),
      meta: { title: "چت", has_ribbon: false, public: true },
    },
    {
      path: "*",
      name: "not-found",
      component: () => import("./notfound.vue"),
      meta: { title: "404" },
    },
  ],
});
